module.exports = __webpack_public_path__ + "static/media/manu-17.f554e087.png";